<script lang="ts">
	import { cn } from '$lib/utils';
	import { inview } from 'svelte-inview';

	let animating = false;
	const options = {};
</script>

<div
	use:inview={options}
	on:inview_enter={() => {
		animating = true;
	}}
	on:inview_leave={() => {
		animating = false;
	}}
	role="figure"
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div
			class="relative row-span-3 mx-auto flex h-full w-full max-w-[200px] flex-row items-center justify-center"
		>
			<div
				class={cn(
					'absolute mx-auto transition-all duration-300 group-hover:h-16 group-hover:w-16',
					animating ? 'h-0 w-0' : 'h-16 w-16'
				)}
			>
				<enhanced:img loading="lazy" src="/static/images/lol/rank/gold.png" alt="Gold" />
			</div>

			<div
				class={cn(
					'absolute mx-auto transition-all duration-500 group-hover:h-0 group-hover:w-0',
					animating ? 'h-24 w-24' : 'h-0 w-0'
				)}
			>
				<enhanced:img loading="lazy" src="/static/images/lol/rank/master.png" alt="Master" />
			</div>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Personalized & Proactive</h3>
			<p class="text-lightTertiary">
				Have Meeko get you that sweet LP by helping you navigate through the various ranks.
			</p>
		</div>
	</div>
</div>
